<!-- 关于河马艺术 -->
<template>
  <div class="home_component news_and_info fd_column">
    <div class="component_title m-b-30">
      <div class="title_mid">
        <div class="title">关于河马艺术</div>
        <div class="subtitle">About Hippo Art</div>
        <!-- <div class="viewMore_more">查看更多</div> -->
      </div>
    </div>
    <div class="component_box">
      <div class="p_as_regards">
        <img
          class="component_img1"
          src="@/assets/Aboutart/image_105.png"
          alt=""
        />
        <img
          class="component_img2"
          src="@/assets/Aboutart/image_106.png"
          alt=""
        />
        <div class="Aboutart_text">
          <div>探索艺术之美，与您共享独特魅力</div>
          <div>
            河马艺术是一家从事艺术设计、艺术品租赁、艺术活动组织、城市公共艺术设计与施工的全产业链提供商。公司以“艺术与科技完美结合，让艺术走进生活，让欣赏艺术变得更简单”为理念，汇聚了众多知名艺术家和丰富的优质艺术资源。积极推动艺术与科技的创新融合，为人们的生活注入艺术之美，为城市打造独特的精神地标，开创全球艺术服务大众的新格局。
          </div>
        </div>
        <img
          class="component_img3"
          src="@/assets/Aboutart/image_107.png"
          alt=""
        />
        <img
          class="component_img5"
          src="@/assets/Aboutart/image_104.png"
          alt=""
        />
        <img
          class="component_img4"
          src="@/assets/Aboutart/image_108.png"
          alt=""
        />
        <img
          class="component_img6"
          src="@/assets/Aboutart/image_109.png"
          alt=""
        />
      </div>
      <div class="m_as_regards">
        <img src="@/assets/Aboutart/m_About.png" alt="" />
        <div class="m_about_text">
          <div>探索艺术之美，与您共享独特魅力</div>
          <div>
            河马艺术是一家从事艺术设计、艺术品租赁、艺术活动组织、城市公共艺术设计与施工的全产业链提供商。公司以“艺术与科技完美结合，让艺术走进生活，让欣赏艺术变得更简单”为理念，汇聚了众多知名艺术家和丰富的优质艺术资源。积极推动艺术与科技的创新融合，为人们的生活注入艺术之美，为城市打造独特的精神地标，开创全球艺术服务大众的新格局。
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
export default {
  // import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    // 这里存放数据
    return {};
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {},
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {
    // this.getList();
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, // 生命周期 - 创建之前
  beforeMount() {}, // 生命周期 - 挂载之前
  beforeUpdate() {}, // 生命周期 - 更新之前
  updated() {}, // 生命周期 - 更新之后
  beforeDestroy() {}, // 生命周期 - 销毁之前
  destroyed() {}, // 生命周期 - 销毁完成
  activated() {}, // 如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang="less" scoped>
// @import url(); 引入公共css类
@import "~@/static/styles/variables.less";
@import "~@/static/styles/index.less";

.component_box {
  margin-top: 0.1563rem;
  position: relative;
  box-sizing: border-box;
  // .normal_flex;
  background-color: transparent;
  border-radius: 6px 6px 6px 6px;
  column-count: 2;
  column-gap: 0;
  .component_img1 {
    width: 1.7969rem;
    height: 1.5469rem;
    margin-right: 0.1042rem;
    transition: transform 0.4s ease;
    &:hover {
      transform: scale(1.07);
    }
  }
  .component_img2 {
    width: 1.7969rem;
    height: 2.5729rem;
    transition: transform 0.4s ease;
    &:hover {
      transform: scale(1.07);
    }
  }
  .component_img3 {
    width: 1.7969rem;
    height: 2.125rem;
    margin-right: 0.1042rem;
    margin-top: 0.3125rem;
    transition: transform 0.4s ease;
    &:hover {
      transform: scale(1.07);
    }
  }
  .component_img4 {
    width: 1.7969rem;
    height: 1.7031rem;
    margin-right: 0.1042rem;
    margin-top: 0.0885rem;
    transition: transform 0.4s ease;
    &:hover {
      transform: scale(1.07);
    }
  }
  .component_img5 {
    width: 0.9844rem;
    height: 0.6354rem;
    margin-top: -1.3021rem;
    margin-left: 0.375rem;
    &:hover {
      transform: scale(1.07) rotate(2deg);
      animation: shake 0.6s ease-in-out 0s infinite alternate;
    }
  }
  @keyframes shake {
    0%,
    100% {
      transform: translateX(0) rotate(0deg);
    }
    20% {
      transform: translateX(-3px) rotate(-2deg);
    }
    40% {
      transform: translateX(3px) rotate(2deg);
    }
    60% {
      transform: translateX(-3px) rotate(-2deg);
    }
    80% {
      transform: translateX(3px) rotate(2deg);
    }
  }
  .component_img6 {
    width: 1.7969rem;
    height: 2.5417rem;
    margin-top: -1.2604rem;
    transition: transform 0.4s ease;
    &:hover {
      transform: scale(1.07);
    }
  }
  .Aboutart_text {
    margin-top: 0.4479rem;
    margin-right: 0.3646rem;
    :first-child {
      font-family: Source-Medium;
      font-weight: 500;
      font-size: 0.1875rem;
      color: #333333;
      line-height: 0.2188rem;
    }
    :last-child {
      font-family: Source-Regular;
      font-weight: 500;
      font-size: 0.0938rem;
      color: #666666;
      line-height: 0.1667rem;
      margin-top: 0.1563rem;
      width: 3.4375rem;
    }
  }
  .m_as_regards {
    width: 100%;
    height: 14.0267rem;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .m_about_text {
    margin-top: 0.4rem;
    :first-child {
      font-family: Source-Medium;
      font-weight: 500;
      font-size: 0.4rem;
      color: #333333;
      line-height: 0.48rem;
    }
    :last-child {
      font-weight: 400;
      font-size: 0.32rem;
      color: #666666;
      line-height: 0.5867rem;
      margin-top: 0.1333rem;
    }
  }
  @media screen and (max-width: 1024px) {
    .p_as_regards {
      display: none;
    }
  }
  @media screen and (min-width: 1024px) {
    .m_as_regards {
      display: none;
    }
  }
}
@media screen and (max-width: 1024px) {
  .component_box {
    column-count: 1 !important;
  }
}
</style>
<style lang="less"></style>
